import React, { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'

const Counter = styled.div`
  z-index: 100;
  position: fixed;
  bottom: 12px;
  left: 12px;
  letter-spacing: 0.03em;
  font-size: 0.75em;
`

export default function SlideCounter ({ artwork, currentArtwork, artworkLength }) {
  const [count, setCount] = useState(0)
  let i = 0
  const workSlides = []

  for (const work of artwork) {
    for (const slides of work.slides) {
      i++
      workSlides.push(slides)
    }
  }
  return (
    <Counter className="counter">
      <p>
        <span className="current-slide">{currentArtwork}</span>/
        <span className="total-slides">{workSlides.length}</span>
        {/* <span className="current-slide">1/9</span> */}
      </p>
    </Counter>
  )
}
